<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="group_journal_adjustments">
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#CheatSheet')">Условные обозначения</button>
                    <button class="mt-2 ml-2 mr-auto" @click="_ProccessJournal">Запросить данные заново</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#SeeSchedule')">Просмотр расписания</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#SeeThemes')">Просмотр тем. плана</button>
                    <button v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" @click="DownloadJournal" class="mt-2 ml-2 mr-auto">Скачать журнал</button>
                    <button v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" @click="DownloadSchedule" class="mt-2 ml-2 mr-auto">Скачать расписание</button>
                    <button v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" @click="DownloadUserList" class="mt-2 ml-2 mr-auto">Выгрузить группу</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#group_journal_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-[2000px] mx-auto fade">
            <div class="flex flex-col md:flex-row md:items-center md:justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p class="ml-2"><b class="text-gradient">Группа:</b> {{journal.Title}}</p>
            </div>
        </div>
        <div class="card flex flex-row items-center justify-center py-3 w-[90%] max-w-[2000px] mx-auto overflow-auto relative fade" style="max-height: calc(100vh - 10rem)" v-if="journal.Program.Themes == undefined || journal.Program.Themes == null || journal.Program.Themes.length < journal.Program.HourNumber">
            <p class="title-sm text-danger animate-pulse">!!!</p>
            <p class="title-sm text-secondary text-center mx-2">Тем. план не заполнен</p>
            <p class="title-sm text-danger animate-pulse">!!!</p>
        </div>
        <div class="card flex flex-row py-3 w-[90%] max-w-[2000px] mx-auto overflow-auto relative fade" style="max-height: calc(100vh - 10rem)">
            <div class="flex flex-col h-full sticky -left-5 bg-inherit z-20">
                <div class="h-[80px] w-full sticky -top-3 z-30 bg-inherit">
                </div>
                <template v-for="(user, index) in journal.Users" :key="index">
                    <div class="flex flex-row">
                        <div class="flex flex-col justify-center px-2 py-1 w-[60px] h-[60px] background-darker">
                            <p class="subtitle text-center">{{index + 1}}.</p>
                        </div>
                        <div class="flex flex-col justify-center px-2 py-1 w-full h-[60px] background-darker">
                            <p class="subtitle text-left">{{user.FIO}}</p>
                        </div>
                    </div>
                </template>
            </div>
            <div class="flex flex-col h-full items-start ml-5">
                <div class="flex flex-row sticky -top-[15px] h-[30px]">
                    <template v-for="(item, index) in journal.Schedule" :key="index">
                        <div class="background-darker h-[30px] w-[60px] px-2 py-1" v-if="journal.Program.Themes[index] !== undefined">
                            <p class="text-center">{{journal.Program.Themes[index] !== undefined && journal.Program.Themes[index].Type == 'Самостоятельная работа' ? '-' : item.Date}}</p>
                        </div>
                    </template>
                </div>
                <div class="flex flex-row sticky top-[15px] h-[30px]">
                    <div class="h-[30px] w-[60px] px-2 py-1" @click="ShowTheme(index)" :class="item.Type == 'Итоговая аттестация' ? 'bg-violet-600 text-white' :item.Type == 'Консультация' ? ' bg-sky-600 text-white' : item.Type == 'Промежуточная аттестация' ? 'bg-green-600 text-white' : item.Type == 'Производственная практика' ? 'bg-orange-600 text-white' : item.Type == 'Самостоятельная работа' ? 'bg-cyan-600 text-white' : item.Title.trim() == '' ? 'bg-red-600 text-white' : 'background-darker' " v-for="(item, index) in journal.Program.Themes" :key="index">
                        <p class="text-center cursor-pointer select-none">{{index + 1}}</p>
                    </div>
                </div>
                <div class="h-[20px] w-full">
                </div>
                <div class="flex flex-row h-[60px] overflow-hidden" v-for="(user, index) in journal.Users" :key="index">
                    <template v-for="(item, key) in journal.Evaluations[user.ID]" :key="key">
                        <div class="h-[60px] w-[60px] background-darker flex flex-col items-center justify-center" v-if="journal.Program.Themes[key] !== undefined">
                            <div v-if="(!(user.ID in journal.Deducted) || (user.ID in journal.Deducted && journal.Schedule[key].DateObj < journal.Deducted[user.ID])) && IsLastOfType(key) && journal.Program.Themes[key] !== undefined" class="h-[58px] w-[58px] background flex flex-col items-center justify-center cursor-pointer select-none" @click="ShowMark(user.ID,key)">
                                <p class="h-[25px] flex items-center justify-center font-bold" v-if="item.Mark[0] !== undefined && item.Mark[0] !== null && item.Mark[0] >= 2 && item.Mark[0] <= 5" :class="item.Mark[0] == 5 ? 'text-green-600' : item.Mark[0] == 4 ? 'text-sky-600' : item.Mark[0] == 3 ? 'text-amber-600' : item.Mark[0] == 2 ? 'text-red-600' : ''">{{item.Mark[0]}}</p>
                                <p class="h-[25px]" v-else></p>
                                <div class="w-[50px] h-0.5 background-darker" v-if="IsLastOfType(key)"></div>
                                <p class="w-[50px] h-[25px] flex items-center justify-center leading-[0.9] text-truncate" v-if="IsLastOfType(key)">{{item.StringMark}}</p>
                            </div>
                            <div v-else-if="(!(user.ID in journal.Deducted) || (user.ID in journal.Deducted && journal.Schedule[key].DateObj < journal.Deducted[user.ID])) && !IsLastOfType(key) && journal.Program.Themes[key] !== undefined" @click="FocusOnMarkInput" class="h-[58px] w-[58px] background flex flex-col items-center justify-center cursor-pointer select-none">
                                <input class="mark-input" :mark-type="markTypes[item.Mark[0]] || markTypes[item.StringMark] || ''" @change="MarkInputChangeMark($event,key,item.ID,user.ID)" @input="ParseMarkInput($event.target.value, $event.target);SetMarkColor($event.target.value, $event.target)" maxlength="1" :value="item.StringMark ? item.StringMark : item.Mark[0] >= 2 && item.Mark[0] <= 5 ? item.Mark[0] : ''">
                            </div>
                            <div v-else class="h-[58px] w-[58px] background flex flex-col items-center justify-center cursor-not-allowed select-none">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-secondary" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>    
    </div>

    <div class="modal dark:text-white" id="CheatSheet" @click="$root.HideModal('#CheatSheet')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Условные обозначения</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#CheatSheet')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="row">
                    <div class="col-12 md:col-6">
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-red-600"></div>
                            <p class="ml-1"> - Не заполена тема</p>
                        </div>
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-orange-600"></div>
                            <p class="ml-1"> - Производственная практика</p>
                        </div>
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-cyan-600"></div>
                            <p class="ml-1"> - Самостоятельная работа</p>
                        </div>
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-sky-600"></div>
                            <p class="ml-1"> - Консультация</p>
                        </div>
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-green-600"></div>
                            <p class="ml-1"> - Промежуточная аттестация</p>
                        </div>
                        <div class="flex flex-row items-center mb-2">
                            <div class="h-[30px] w-[60px] px-2 py-1 bg-violet-600"></div>
                            <p class="ml-1"> - Итоговая аттестация</p>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="flex flex-row items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-secondary" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />
                            </svg>
                            <p class="ml-1"> - Пользователь отчислен</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="SeeTheme" @click="$root.HideModal('#SeeTheme')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр темы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeTheme')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="$root.HasRole($store.state.adminRole)">
                    <p class="subtitle">ID</p>
                    <p class="text-right">{{$root.IsEmpty(currentTheme.ID)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Модуль</p>
                    <p class="text-right">{{currentTheme.Module !== undefined && currentTheme.Module !== null && currentTheme.Module > 0 ? currentTheme.Module : '-'}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Название</p>
                    <p class="text-right">{{$root.IsEmpty(currentTheme.Title)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Вид занятия</p>
                    <p class="text-right">{{$root.IsEmpty(currentTheme.Type)}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="SeeMark" @click="$root.HideModal('#SeeMark')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр оценки</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeMark')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="$root.HasRole($store.state.adminRole)">
                    <p class="subtitle">ID</p>
                    <p>{{$root.IsEmpty(currentMark.ID)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Оценка</p>
                    <p>{{currentMark.Mark !== undefined && currentMark.Mark !== null && currentMark.Mark[0] >= 2 && currentMark.Mark[0] <= 5 ? currentMark.Mark[0] : '-'}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Пометка</p>
                    <p>{{currentMark.StringMark !== undefined && currentMark.StringMark !== null && currentMark.StringMark.trim() !== "" ? currentMark.StringMark : '-'}}</p>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeMark');$root.ShowModal('#ChangeMark')">Изменить</button>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="ChangeMark" @click="$root.HideModal('#ChangeMark')">
        <form class="modal-dialog" @submit="ChangeMark" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение оценки</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeMark')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Оценка</label>
                    <input type="number" class="input sm:ml-auto" min="0" max="5" ref="mark" :value="currentMark.Mark >= 2 && currentMark.Mark <= 5 ? currentMark.Mark : ''">
                </div>
                <div class="form-group w-full my-2" v-if="journal.Evaluations[currentMark.UserID] !== undefined && journal.Evaluations[currentMark.UserID] !== null && IsLastOfType(journal.Evaluations[currentMark.UserID].indexOf(currentMark))">
                    <label class="input-label">Пометка</label>
                    <select class="input sm:ml-auto" ref="string_mark" :value="currentMark.StringMark">
                        <option value="">Не выбрано</option>
                        <option value="зачет">зачет</option>
                        <option value="незачет">незачет</option>
                        <option value="Не явился">Не явился</option>
                    </select>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeMark')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeMark')">Изменить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="SeeSchedule" @click="$root.HideModal('#SeeSchedule')">
        <div class="modal-dialog !max-w-6xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр расписания</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeSchedule')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>№</th>
                        <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                        <th>Модуль</th>
                        <th>Тема</th>
                        <th>Дата</th>
                        <th>Перподаватель</th>
                        <th>Вид занятия</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in journal.Schedule" :key="index">
                            <th>{{index + 1}}</th>
                            <th v-if="$root.HasRole($store.state.adminRole)">{{item.ID}}</th>
                            <td class="text-center">{{journal.Program.Themes[index] !== undefined && journal.Program.Themes[index] !== null && journal.Program.Themes[index].Module > 0 ? journal.Program.Themes[index].Module : '-'}}</td>
                            <td class="text-center">{{journal.Program.Themes[index] !== undefined && journal.Program.Themes[index] !== null ? journal.Program.Themes[index].Title : '-'}}</td>
                            <td class="text-center" v-if="journal.Program.Themes[index] !== undefined && journal.Program.Themes[index] !== null && journal.Program.Themes[index].Type == 'Самостоятельная работа'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mx-auto text-secondary">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                </svg>
                            </td>
                            <td class="text-center" v-else>
                                <input type="date" class="input sm:ml-auto !bg-transparent" @blur="ChangeHourDate($event, item.ID, index)" :value="$root.FormatInputDate(item.FullDate)">
                            </td>
                            <td class="text-center" v-if="journal.Program.Themes[index] !== undefined && journal.Program.Themes[index] !== null && journal.Program.Themes[index].Type == 'Самостоятельная работа'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mx-auto text-secondary">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                </svg>
                            </td>
                            <td class="text-center" v-else>
                                <select class="input sm:ml-auto !bg-transparent" @change="ChangeHourTeacher($event, item.ID, index)" :value="item.Teacher !== null ? item.Teacher.ID : ''">
                                    <option value="">Не выбрано</option>
                                    <option v-for="(user, index) in journal.Teachers" :key="index" :value="user.ID">{{user.FIO}}</option>
                                </select>
                            </td>
                            <td class="text-center">{{journal.Program.Themes[index] !== undefined && journal.Program.Themes[index] !== null ? journal.Program.Themes[index].Type : '-'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
    <div class="modal dark:text-white" id="SeeThemes" @click="$root.HideModal('#SeeThemes')">
        <div class="modal-dialog !max-w-5xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр тем. плана программы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>
                            <button class="rounded-button" @click="$root.HideModal('#SeeThemes');$root.ShowModal('#NewTheme')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                        <th>№</th>
                        <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                        <th>Модуль</th>
                        <th>Название</th>
                        <th>Вид занятия</th>
                        <th>
                        </th>
                        <th>
                        </th>
                        <th>
                            <button class="text-red-600" @click="DeleteMultipleThemes">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(theme, index) in journal.Program.Themes" :key="index">
                            <th>
                                <div class="flex flex-col justify-center items-center h-full">
                                    <input class="checkbox before:!bg-secondary dark:before:!bg-secondary" type="checkbox" :ref="'delete_theme_' + index">
                                </div>
                            </th>
                            <th>{{index + 1}}</th>
                            <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{theme.ID}}</td>
                            <td>{{theme.Module}}</td>
                            <td>{{theme.Title}}</td>
                            <td>{{theme.Type}}</td>
                            <th>
                                <button class="text-blue-600" @click="$root.HideModal('#SeeThemes');SeeProgramTheme(index, '#ChangeTheme')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button class="text-orange-600" @click="$root.HideModal('#SeeThemes');SeeProgramTheme(index, '#ChangeThemePosition')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button class="text-red-600" @click="DeleteTheme(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewTheme" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')">
        <form class="modal-dialog" @submit="NewTheme" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Добавление темы в тем. план</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Модуль</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="theme_module">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Название</label>
                    <input type="text" class="input sm:ml-auto" ref="theme_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Вид занятия</label>
                    <select class="input sm:ml-auto" ref="theme_type">
                        <option v-for="(item, index) in thematic_plan_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Объём часов</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="theme_hour_number">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeTheme" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')">
        <form class="modal-dialog" @submit="ChangeTheme" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение темы в тем. плане</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Модуль</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="current_theme_module" :value="currentTheme.Module">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Название</label>
                    <input type="text" class="input sm:ml-auto" ref="current_theme_title" :value="currentTheme.Title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Вид занятия</label>
                    <select class="input sm:ml-auto" ref="current_theme_type" :value="currentTheme.Type">
                        <option v-for="(item, index) in thematic_plan_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme')">Изменить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeThemePosition" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')">
        <form class="modal-dialog" @submit="ChangeThemePosition" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение позиции темы в тем. плане</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-row items-center justify-center">
                    <p class="input w-20">{{journal.Program.Themes.indexOf(currentTheme) + 1}}</p>
                    <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
                        </svg>
                    </p>
                    <div>
                        <input type="number" min="1" class="input w-20" ref="current_theme_position" :value="journal.Program.Themes.indexOf(currentTheme) + 1">
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeThemePosition')">Изменить</button>
            </div>
        </form>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
    components: {
        Navigation
    },
    data() {
        return {
            markTypes: {
                5: "perfect",
                4: "good",
                3: "ok",
                2: "bad",
                "Н": "absent",
            },
            journal: {
                ID: "",
                Title: "",
                IsClosed: false,
                Teachers: [],
                Users: [],
                Schedule: [],
                Evaluations: {},
                Deducted: {},
                Program: {
                    ID: "",
                    Abbreviation: "",
                    Title: "",
                    HourNumber: 0,
                    Themes: []
                }
            },
            currentTheme : {
                ID: "",
                Module: "",
                Number: 0,
                Title: "",
                Type: "",
            },
            currentMark : {
                ID: "",
                UserID: "",
                Mark: [],
                StringMark: ""
            },
            currentScheduleHour: {
                ID: "",
                Number: 0,
                FullDate: "",
                Date: "",
                Teacher: {
                    ID: "",
                    FIO: ""
                }
            },
            thematic_plan_type_items: [],
            navigationKey: "nav",
            title: "Журнал группы"
        }
    },
    methods: {
        IsLastOfType(index) {
            let theme = this.journal.Program.Themes[index]

            if (!theme) return false

            if (theme.Type === 'Производственная практика' || theme.Type === 'Консультация' || theme.Type === 'Промежуточная аттестация' || theme.Type === 'Итоговая аттестация') {
                if (this.journal.Program.Themes.length == 1 && index == 0) return true
                if (index == this.journal.Program.Themes.length - 1) return true
                if (index == 0 && this.journal.Program.Themes[1].Type !== theme.Type) return true
                if (this.journal.Program.Themes[index + 1].Type !== theme.Type && this.journal.Program.Themes[index - 1].Type === theme.Type) return true
                if (this.journal.Program.Themes[index + 1].Type !== theme.Type && this.journal.Program.Themes[index - 1].Type !== theme.Type) return true
            }
            return false
        },
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        TeacherByID(id) {
            let teacher = null

            for (var i in this.journal.Teachers) {
                var t = this.journal.Teachers[i]
                if (t.ID == id) {
                    teacher = t
                    break
                }
            }

            return teacher
        },
        FocusOnMarkInput(e) {
            if (e.target.querySelector("input") !== null) e.target.querySelector("input").focus()
        },
        ParseMarkInput(value, target) {
            if (value.length > 1) value = value[0]
            if (Number(value) < 2) value = ""
            if (Number(value) > 5) value = 5
            if (Number.isNaN(Number(value))) {
                if (value.toUpperCase() != "Н") value = ""
                if (value.toUpperCase() == "Н") value = "Н"
            }
            
            target.value = value
        },
        SetMarkColor(value, target) {
            target.setAttribute('mark-type', this.markTypes[value] || "")
        },
        async _SelectData() {
            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/thematic_plan/type_of_occupation", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.thematic_plan_type_items = res.data.select.variants
        },
        async _ProccessJournal() {
            this.$root.StartLoading()

            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/list?me=true", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let my_groups = []

            for (var i in res.data.study_groups) {
                var g = res.data.study_groups[i]
                my_groups.push(g.id)
            }

            if (this.$root.HasRole(this.$store.state.employeeRole) && !my_groups.includes(this.$store.state.journal_id)) {
                this.$root.ShowToast("У вас нет доступа к выбранному журналу", "error", 8000)
                this.$router.push({name: 'GroupList'})
                return
            }

            res = await fetch(this.$store.state.aeApiAddr + `/v1.0/study_groups/by_id/${this.$store.state.journal_id}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let group = res.data.study_group

            var result = await fetch(this.$store.state.aeApiAddr + `/v1.0/study_groups/pedagogical_load/by_id/${this.$store.state.journal_id}/users`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let blackList = []
            let pedLoadUsers = []

            for (var i in result.data.workers) {
                var user = result.data.workers[i]
                if (!blackList.includes(user.id)) {
                    pedLoadUsers.push({
                        ID: user.id,
                        FIO: `${user.worker.surname} ${user.worker.name} ${user.worker.middle_name}`
                    })
                    blackList.push(user.id)
                }
            }

            let users = []

            for (var i in group.orders.order_of_enrollment.students) {
                var user = group.orders.order_of_enrollment.students[i]

                var result = await fetch(this.$store.state.apiAddr + `/v1.0/users/by_id/${user}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                }).then(response => {return response.json()})
                .catch(error => {
                    this.$root.Fatal()
                })

                var user = result.data.user

                users.push({
                    ID: user.id,
                    FIO: `${user.student.surname} ${user.student.name[0]}. ${user.student.middle_name !== "" ? user.student.middle_name[0] + "." : ""}`
                })
            }

            for (var i in group.orders.order_of_enrollment.listeners) {
                var user = group.orders.order_of_enrollment.listeners[i]

                var result = await fetch(this.$store.state.apiAddr + `/v1.0/users/by_id/${user}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                }).then(response => {return response.json()})
                .catch(error => {
                    this.$root.Fatal()
                })

                var user = result.data.user

                users.push({
                    ID: user.id,
                    FIO: `${user.listener.surname} ${user.listener.name[0]}. ${user.listener.middle_name !== "" ? user.listener.middle_name[0] + "." : ""}`
                })
            }

            for (var i in group.orders.order_of_enrollment.workers) {
                var user = group.orders.order_of_enrollment.workers[i]

                var result = await fetch(this.$store.state.apiAddr + `/v1.0/users/by_id/${user}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                }).then(response => {return response.json()})
                .catch(error => {
                    this.$root.Fatal()
                })

                var user = result.data.user

                users.push({
                    ID: user.id,
                    FIO: `${user.worker.surname} ${user.worker.name[0]}. ${user.worker.middle_name !== "" ? user.worker.middle_name[0] + "." : ""}`
                })
            }

            users.sort((a, b) => a.FIO < b.FIO ? -1 : 1)

            let schedule = []

            for (var i in group.schedule.education_hours) {
                var hour = group.schedule.education_hours[i]

                var dateObject = new Date(hour.date)
                var fullDate = this.$root.FormatDate(hour.date)

                var buf = this.$root.FormatDate(hour.date).split(".")

                buf.pop()

                var date = buf.join(".")

                var teacher = null

                if (hour.teacher_id != "000000000000000000000000") {
                    for (var i in pedLoadUsers) {
                        var user = pedLoadUsers[i]

                        if (user.ID == hour.teacher_id) {
                            teacher = {
                                ID: user.ID,
                                FIO: user.FIO
                            }
                            break
                        }
                    }
                }

                schedule.push({
                    ID: hour.id,
                    Number: hour.number,
                    DateObj: dateObject,
                    FullDate: fullDate,
                    Date: date,
                    Teacher: teacher
                })
            }

            let evaluations = {}

            for (var i in group.evaluations.data) {
                var evaluation = group.evaluations.data[i]

                var user_evaluations = []

                for (var j in evaluation) {

                    if (j >= schedule.length) {
                        break
                    }

                    var item = evaluation[j]

                    user_evaluations.push({
                        ID: item.id,
                        UserID: item.listener_id,
                        Mark: [item.evaluations[0]],
                        StringMark: item.string_eval
                    })
                }

                evaluations[i] = user_evaluations
            }

            let program = null

            var result = await fetch(this.$store.state.aeApiAddr + `/v1.0/programs/by_id/${group.program_id}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let thematic_plan = []

            for (var i in result.data.program.thematic_plan.themes) {
                var theme = result.data.program.thematic_plan.themes[i]

                if (theme === undefined || theme === null) {
                    continue
                }

                thematic_plan.push({
                    ID: theme.id,
                    Module: theme.module,
                    Number: theme.number,
                    Title: theme.title,
                    Type: theme.type
                })
            }

            let deducted = {}

            for (var i in group.orders.deducted) {
                const deductedUserInfo = group.orders.deducted[i]
                deducted[deductedUserInfo.user_id] = new Date(deductedUserInfo.date)
            }

            program = {
                ID: result.data.program.id,
                Abbreviation: result.data.program.abbreviation,
                Title: result.data.program.title,
                HourNumber: result.data.program.number_of_hours,
                Themes: thematic_plan
            }

            this.journal = {
                ID: group.id,
                Title: group.title,
                IsClosed: group.is_closed,
                Teachers: pedLoadUsers,
                Users: users,
                Schedule: schedule,
                Evaluations: evaluations,
                Deducted: deducted,
                Program: program
            }

            this.$root.EndLoading()
        },
        ShowTheme(index) {
            this.currentTheme = this.journal.Program.Themes[index]

            this.$root.ShowModal('#SeeTheme')
        },
        ShowMark(userID, index) {
            this.currentMark = this.journal.Evaluations[userID][index]

            this.$root.ShowModal('#SeeMark')
        },
        UpdateCurrentMark(userID,index) {
            this.currentMark = this.journal.Evaluations[userID][index]
        },
        SetCurrentHour(index, selector) {
            this.currentScheduleHour = this.journal.Schedule[index]

            if (selector !== undefined && selector !== null) {
                this.$root.ShowModal(selector)
            }
        },
        ChangeMark(e) {
            e.preventDefault()

            let index = this.journal.Evaluations[this.currentMark.UserID].indexOf(this.currentMark)

            let evaluationData = {
                id_evaluation: this.currentMark.ID,
                id_study_group: this.journal.ID
            }

            let mark = Number(this.$refs.mark.value)

            if (mark != 0 && !(mark >= 2 && mark <= 5)) {
                this.$root.ShowToast("Выставлена некорректная оценка", "error")
                this.$refs.mark.value = this.journal.Evaluations[this.currentMark.UserID][index].Mark[0]
                return
            }

            evaluationData["evaluations"] = [mark]

            if (this.IsLastOfType(index)) {
                let string_mark = this.$refs.string_mark.value

                evaluationData["string_eval"] = string_mark
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/evaluations/evaluation", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify(evaluationData)
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Оценка успешно изменена", "success")
                this.journal.Evaluations[this.currentMark.UserID][index].Mark = evaluationData["evaluations"]
                if (this.IsLastOfType(index)) {
                    this.journal.Evaluations[this.currentMark.UserID][index].StringMark = evaluationData["string_eval"]
                }
                this.UpdateCurrentMark(this.currentMark.UserID, index)
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        MarkInputChangeMark(e, index, markID, userID) {
            let mark = e.target.value.toUpperCase() == "Н" ? "Н" : Number(e.target.value)

            let evaluationData = {
                id_evaluation: markID,
                id_study_group: this.journal.ID
            }

            if (mark != 0 && !((mark >= 2 && mark <= 5) || mark == "Н")) {
                this.$root.ShowToast("Выставлена некорректная оценка", "error")
                e.target.value = this.journal.Evaluations[userID][index].Mark[0]
                return
            }

            if (typeof mark === "string") {
                evaluationData["string_eval"] = mark
                evaluationData["evaluations"] = this.journal.Evaluations[userID][index].Mark
            }
            else {
                evaluationData["string_eval"] = ""
                evaluationData["evaluations"] = [mark]
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/evaluations/evaluation", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify(evaluationData)
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) {
                    if (typeof mark === "string") e.target.value = this.journal.Evaluations[userID][index].StringMark
                    else e.target.value = this.journal.Evaluations[userID][index].Mark[0]

                    return
                }
                this.$root.ShowToast("Оценка успешно изменена", "success")
                this.journal.Evaluations[userID][index].StringMark = evaluationData["string_eval"]
                this.journal.Evaluations[userID][index].Mark = evaluationData["evaluations"]
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeHour(e) {
            e.preventDefault()

            let index = this.journal.Schedule.indexOf(this.currentScheduleHour)

            let hourData = {
                id_education_hour: this.currentScheduleHour.ID,
                id_study_group: this.journal.ID
            }

            let teacher = this.$refs.current_hour_teacher.value

            let date = this.$refs.current_hour_date.value

            hourData["teacher_id"] = teacher.trim() == "" ? undefined : teacher
            hourData["date"] = date.trim() == "" ? undefined : date + "T00:00:00Z"

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/schedules/education_hour", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify(hourData)
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Учебный час успешно измененён", "success")
                if (hourData["date"] !== undefined) {
                    var dateObject = new Date(hourData["date"])
                    var fullDate = this.$root.FormatDate(hourData["date"])

                    var buf = this.$root.FormatDate(hourData["date"]).split(".")

                    buf.pop()

                    var date = buf.join(".")

                    this.journal.Schedule[index].Date = date
                    this.journal.Schedule[index].FullDate = fullDate
                    this.journal.Schedule[index].DateObj = dateObject
                }

                if (hourData["teacher_id"] !== undefined) {
                    this.journal.Schedule[index].Teacher = this.TeacherByID(hourData["teacher_id"])
                }
            })
            .catch(error => {
                console.log(error)
                this.$root.Fatal()
            })
        },
        ChangeHourTeacher(e, id, index) {
            e.preventDefault()

            let hourData = {
                id_education_hour: id,
                id_study_group: this.journal.ID
            }

            let teacher = e.target.value
            hourData["teacher_id"] = teacher.trim() == "" ? undefined : teacher

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/schedules/education_hour", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify(hourData)
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Учебный час успешно измененён", "success")
                if (hourData["teacher_id"] !== undefined) {
                    this.journal.Schedule[index].Teacher = this.TeacherByID(hourData["teacher_id"])
                }
            })
            .catch(error => {
                console.log(error)
                this.$root.Fatal()
            })
        },
        ChangeHourDate(e, id, index) {
            e.preventDefault()

            let hourData = {
                id_education_hour: id,
                id_study_group: this.journal.ID
            }

            let date = e.target.value
            hourData["date"] = date.trim() == "" ? undefined : date + "T00:00:00Z"

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/schedules/education_hour", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify(hourData)
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Учебный час успешно измененён", "success")
                if (hourData["date"] !== undefined) {
                    var dateObject = new Date(hourData["date"])
                    var fullDate = this.$root.FormatDate(hourData["date"])

                    var buf = this.$root.FormatDate(hourData["date"]).split(".")

                    buf.pop()

                    var date = buf.join(".")

                    this.journal.Schedule[index].Date = date
                    this.journal.Schedule[index].FullDate = fullDate
                    this.journal.Schedule[index].DateObj = dateObject
                }
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async DownloadJournal() {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + "/v1.0/ae/journals/", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.journal.ID
                    })
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать журнал", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", `журнал_${this.journal.Title}.xlsx`)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать журнал", "error")
            }
            
        },
        async DownloadSchedule() {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + "/v1.0/ae/journals/schedule", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.journal.ID
                    })
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать расписание", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", `расписание_${this.journal.Title}.xlsx`)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать расписание", "error")
            }
            
        },
        async DownloadUserList() {
            let users = []

            for (var i in this.journal.Users) {
                users.push(this.journal.Users[i].ID)
            }

            try {
                var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/reports/users/`, {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        users: users
                    })
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось выгрузить учебную группу", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", res.headers.get('Content-Disposition').split('filename=')[1].split('"')[1])
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось выгрузить учебную группу", "error")
            }
        },
        SeeProgramTheme(index, selector) {
            this.currentTheme = this.journal.Program.Themes[index]
            this.$root.ShowModal(selector)
        },
        NewTheme(e) {
            e.preventDefault()

            let title = this.$refs.theme_title.value
            let mod = this.$refs.theme_module.value
            let type = this.$refs.theme_type.value
            let hour_number = this.$refs.theme_hour_number.value

            let thematicPlan = []

            for (var i in this.journal.Program.Themes) {
                var theme = this.journal.Program.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            thematicPlan.push({
                "number": this.journal.Program.Themes.length > 0 ? Number(this.journal.Program.Themes[this.journal.Program.Themes.length-1].Number) + 1 : 1,
                "title": title,
                "type": type,
                "volume": Number(hour_number),
                "module": Number(mod)
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.journal.Program.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this._ProccessJournal().then(()=>{this.$root.ShowToast("Новая тема успешно добавлена", "success");this.$root.ShowModal('#SeeThemes')})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeTheme(e) {
            e.preventDefault()

            let title = this.$refs.current_theme_title.value
            let mod = this.$refs.current_theme_module.value
            let type = this.$refs.current_theme_type.value

            let thematicPlan = []

            let index = this.journal.Program.Themes.indexOf(this.currentTheme)

            for (var i in this.journal.Program.Themes) {

                var theme = this.journal.Program.Themes[i]

                if (i == index) {
                    thematicPlan.push({
                        "id": theme.ID,
                        "number": Number(i) + 1,
                        "title": title,
                        "type": type,
                        "volume": 1,
                        "module": Number(mod)
                    })
                    continue
                }
                
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.journal.Program.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this._ProccessJournal().then(()=>{this.$root.ShowToast("Данные темы успешно изменены", "success");this.$root.ShowModal('#SeeThemes')})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeThemePosition(e) {
            e.preventDefault()

            let position = Number(this.$refs.current_theme_position.value) - 1
            let old_position = this.journal.Program.Themes.indexOf(this.currentTheme)

            if (position >= this.journal.Program.Themes.length) {
                this.$root.ShowToast("Невозможно произвести замену: элемент с таким номером не найден", "error")
            }

            let thematicPlan = []

            for (var i in this.journal.Program.Themes) {
                var theme = this.journal.Program.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }
            
            let old_item = JSON.parse(JSON.stringify(thematicPlan[old_position]))
            let new_item = JSON.parse(JSON.stringify(thematicPlan[position]))

            thematicPlan[position] = old_item
            thematicPlan[position].number = Number(position) + 1
            thematicPlan[old_position] = new_item
            thematicPlan[old_position].number = Number(old_position) + 1

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.journal.Program.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this._ProccessJournal().then(()=>{this.$root.ShowToast("Замена полей успешно произведена", "success");this.$root.ShowModal('#SeeThemes')})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteTheme(index) {
            let thematicPlan = []

            for (var i in this.journal.Program.Themes) {

                if (i == index) continue
                var theme = this.journal.Program.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": i > index ? Number(i) : Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.journal.Program.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this._ProccessJournal().then(()=>{this.$root.ShowToast("Тема успешно удалена", "success");this.$root.ShowModal('#SeeThemes')})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteMultipleThemes() {
            
            function DeleteTheme(thematic_plan, index) {

                let thematicPlan = []
                for (var i in thematic_plan) {

                    if (i == index) continue
                    var theme = thematic_plan[i]
                    thematicPlan.push({
                        "id": theme.id,
                        "number": i > index ? Number(i) : Number(i) + 1,
                        "title": theme.title,
                        "type": theme.type,
                        "volume": 1,
                        "module": theme.module
                    })
                }

                return thematicPlan
            }

            let themes_to_delete = []
            for (var i in this.journal.Program.Themes) {
                var inp = this.$refs[`delete_theme_${i}`][0]
                if (inp !== undefined && inp !== null) if (inp.checked) themes_to_delete.push(Number(i))
            }

            let thematicPlan = []

            for (var i in this.journal.Program.Themes) {
                var theme = this.journal.Program.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            themes_to_delete.forEach((value, index)=>{
                thematicPlan = DeleteTheme(thematicPlan, value)

                for (var j = index + 1; j < themes_to_delete.length; j++) themes_to_delete[j] -= 1
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.journal.Program.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this._ProccessJournal(()=>{this.$root.ShowToast("Выбранные темы успешно удалены", "success");this.$root.ShowModal('#SeeThemes')})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        }
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.employeeRole) || this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                setTimeout( () => { this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000) }, 1000 )
                this.$router.push({name: 'Home'})
                return
            }
            this.$store.commit('updateJournalID')
            if (this.$store.state.journal_id == undefined || this.$store.state.journal_id == null) {
                setTimeout( () => { this.$root.ShowToast("Журнал не найден", "error", 8000) }, 1000 )
                this.$router.push({name: 'GroupList'})
                return
            }

            this._SelectData()

            this._ProccessJournal().then(()=>{
                this.$root.EndLoading()
            })
        }) 
    }
}
</script>